import React from 'react';
import { Header, flexRender } from '@tanstack/react-table';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

interface ColumnMeta {
  className?: string;
}

interface SortableTableHeaderProps<T> {
  header: Header<T, unknown>;
}

const SortableTableHeader = <T,>({ header }: SortableTableHeaderProps<T>) => {
  return (
    <th
      role={header.column.columnDef.enableSorting ? 'button' : undefined}
      colSpan={header.colSpan}
      onClick={header.column.columnDef.enableSorting ? header.column.getToggleSortingHandler() : undefined}
      style={{ width: header.column.columnDef.size, userSelect: 'none' }}
      className={header.column.columnDef.enableSorting ? 'cursor-pointer' : 'cursor-default'}
    >
      <div
        className={`d-flex justify-content-start align-items-start gap-2 ${
          (header.column.columnDef.meta as ColumnMeta)?.className
        }`}
      >
        <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>
        {header.column.columnDef.enableSorting && (
          <div>
            {
              {
                asc: <FaArrowDown />,
                desc: <FaArrowUp />,
                default: (
                  <span>
                    <FaArrowDown />
                    <FaArrowUp />
                  </span>
                ),
              }[(header.column.getIsSorted() as string) || 'default']
            }
          </div>
        )}
      </div>
    </th>
  );
};

export default SortableTableHeader;
